import {TranslateService} from "@stefanholzapfel/lit-translate";
import {SpUiTaxon} from "../components/inputs/sp-taxon-input/sp-taxon-input";

export class SpTaxonService {
    public static getUnknownTaxon(): SpUiTaxon {
        return {
            id: 'unknown',
            label: TranslateService.translate('TAXON_FIELD_OPTION_UNKNOWN') as string
        }
    }
}
